// Mara's parameters, and nothing else.
//
// Companion bond used to be one number with one meaning: how long Mara waits before answering
// again. That made every tier a strictly better tier, so the only question the party screen ever
// asked was when. `revealScale` gives the tier a second axis — how long the litany keeps naming
// the road through walls — which is the parameter a wick-servant actually punishes you for,
// because a snuffing servant is a thing you have to find before its 2.6 s runs out.
//
// This module is the whole of that rule. It reads no clock, no scene and no DOM, so the tier
// table can be asserted directly instead of inferred from a running game.
export const COMPANION = Object.freeze({ cooldown: 9, revealDuration: 5.5, interruptRange: 8 });

const companionBondTier = (tier, label, bond, cooldownScale, revealScale, note) => Object.freeze({
  tier,
  label,
  bond,
  cooldownScale,
  revealScale,
  cooldown: Math.round(COMPANION.cooldown * cooldownScale * 100) / 100,
  revealDuration: Math.round(COMPANION.revealDuration * revealScale * 100) / 100,
  note,
});

export const COMPANION_BOND_TIERS = Object.freeze([
  companionBondTier(0, 'Wary', 0, 1, 1, 'Mara answers late, names one thing at a time, and only when the road leaves no other choice.'),
  companionBondTier(1, 'Attentive', 2, 0.8, 1.25, 'Mara listens for the plan before she speaks, and the road stays lit a little longer behind her.'),
  companionBondTier(2, 'Devoted', 4, 0.6, 1.55, 'Mara is already answering the danger you have not seen yet, and the litany reaches twice as far into the dark.'),
  companionBondTier(3, 'Sworn', 6, 0.45, 2, 'The litany arrives before the need is finished, and nothing on the road stays hidden for long.'),
]);

export function getCompanionBondTier(bond = 0) {
  const value = Math.max(0, Number(bond) || 0);
  for (let index = COMPANION_BOND_TIERS.length - 1; index > 0; index -= 1) if (value >= COMPANION_BOND_TIERS[index].bond) return COMPANION_BOND_TIERS[index];
  return COMPANION_BOND_TIERS[0];
}

export function getCompanionProfile(bond = 0) {
  const tier = getCompanionBondTier(bond);
  return {
    bond: Math.max(0, Number(bond) || 0),
    tier: tier.tier,
    label: tier.label,
    cooldown: tier.cooldown,
    revealDuration: tier.revealDuration,
    note: tier.note,
    nextTier: COMPANION_BOND_TIERS[tier.tier + 1] || null,
  };
}
